import React from 'react';

interface TableRowProps {
    children: React.ReactNode;
    additionalClasses?: string;
}

const TableRow: React.FC<TableRowProps> = (props) => {
    const { children, additionalClasses } = props;
    return <tr className={additionalClasses}>{children}</tr>;
};

export default TableRow;
